import { Injectable, ElementRef } from "@angular/core";
import { AbstractControl, ValidatorFn, FormGroup } from "@angular/forms";
import { MyAuthService } from "./../authentication/auth.service";
import { Router, ActivatedRoute } from "@angular/router";
import { Observable, BehaviorSubject } from "rxjs";

import * as $ from "jquery";
import * as jsPDF from "jspdf";
import * as html2canvas from "html2canvas";
import domtoimage from "dom-to-image";

@Injectable({
  providedIn: "root"
})
export class SharedService {
  public userInfo: any;
  public showBenefits: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(
    false
  );
  public openBenefits = this.showBenefits.asObservable();
  public showPlans = false;
  public showLoginRegister: BehaviorSubject<boolean> = new BehaviorSubject<
    boolean
  >(false);
  public openLoginRegister = this.showLoginRegister.asObservable();
  public showLoginRegisterModal = false;
  // public showLoginOrRegister = 1;
  public showLoginOrRegister: BehaviorSubject<number> = new BehaviorSubject<
    number
  >(1);
  public getLoginOrRegister = this.showLoginOrRegister.asObservable();
  public registrationType: BehaviorSubject<number> = new BehaviorSubject<
    number
  >(0);
  public getRegistrationType = this.registrationType.asObservable();
  public mobileVerify: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(
    false
  );
  public showMobileVerify = this.mobileVerify.asObservable();
  public showMobileVerificationBox = false;
  public subscribedEmail = "";
  public showBuySellText: boolean = true;
  constructor(private _route: Router, private _auth: MyAuthService) {
    this._auth.getUserDetails();
    this._auth.userData.subscribe(userInfo => {
      this.userInfo = userInfo;
    });
  }

  public toggleBenefits() {
    this.showPlans = !this.showPlans;
    this.showBenefits.next(this.showPlans);
  }

  /* public toggleBenefits() {
    this.showPlans = !this.showPlans;
    this.showBenefits.next(this.showPlans);
  } */

  public toggleMobileVerify(email) {
    this.subscribedEmail = email;
    this.showMobileVerificationBox = !this.showMobileVerificationBox;
    this.mobileVerify.next(this.showMobileVerificationBox);
  }

  public toggleLoginRegisterModal(regType, toOpen) {
    this.showLoginRegisterModal = !this.showLoginRegisterModal;
    // this.showLoginOrRegister = toOpen;
    this.registrationType.next(regType);
    this.showLoginOrRegister.next(toOpen);
    this.showLoginRegister.next(this.showLoginRegisterModal);
  }

  getLabel(keyword) {
    if (keyword) {
      keyword = keyword.split("_").join(" ");
      return this.capitalizeFirstLetter(keyword);
    } else {
      return keyword;
    }
  }

  capitalizeFirstLetter(string) {
    if (string !== "") {
      return string.charAt(0).toUpperCase() + string.slice(1);
    } else {
      return string;
    }
  }

  removeFirstWord(field, val) {
    return field.replace(val, "");
  }

  getFixed(num) {
    const num1 = parseFloat(num);
    let n =
      num1 < 0 && !isNaN(num1)
        ? ((Math.floor(Math.abs(num1) * 1000) * -1) / 1000).toFixed(2)
        : num1.toFixed(2);
    // console.log(num, num1, n);
    n = n !== "NaN" ? n : "-";
    return typeof num === "string" && n === "-" ? num : n;
  }

  getFixed4dec(num) {
    const num1 = parseFloat(num);
    let n =
      num1 < 0 && !isNaN(num1)
        ? (Math.floor(Math.abs(num1) * 100000) * -1) / 100000
        : num1.toFixed(4);
    // console.log(num, num1, n);
    n = n !== "NaN" ? n : "-";
    return typeof num === "string" && n === "-" ? num : n;
  }

  getQuarterString(value) {
    value = value.replace("Year", "");
    if (value[value.length - 1] === "3") {
      return value.replace("03", " Mar");
    }
    if (value[value.length - 1] === "6") {
      return value.replace("06", " Jun");
    }
    if (value[value.length - 1] === "9") {
      return value.replace("09", " Sep");
    }
    if (value[value.length - 1] === "2") {
      return value.replace("12", " Dec");
    }
    return value;
  }

  getHalfYearlyString(value) {
    value = value.replace("Y", "");
    if (value[value.length - 1] === "3") {
      return value.replace("03", " Mar");
    }
    if (value[value.length - 1] === "6") {
      return value.replace("06", " Jun");
    }
    if (value[value.length - 1] === "9") {
      return value.replace("09", " Sep");
    }
    if (value[value.length - 1] === "2") {
      return value.replace("12", " Dec");
    }

    return value;
  }

  getFieldsSortedAsc(data, field) {
    return data.sort((a, b) => {
      return a[field] > b[field] ? 1 : b[field] > a[field] ? -1 : 0;
    });
  }
  getDate(dt) {
    const d = new Date(dt);
    return d.getDate() + "-" + (d.getMonth() + 1) + "-" + d.getFullYear();
  }
  getYMDDate(dt) {
    const d = new Date(dt);
    return (
      d.getFullYear() +
      "-" +
      (d.getMonth() + 1) +
      "-" +
      ("0" + d.getDate()).slice(-2)
    );
  }
  getDataInDesc(data, field) {
    return data.sort((a, b) => {
      return a[field] < b[field] ? 1 : b[field] < a[field] ? -1 : 0;
    });
  }

  printDoc(ele, name) {
    $(".noprint").addClass("hide");
    $("#disclaimer").toggleClass("hide");
    if (name === "report") {
      $("table.table").addClass("table-padding");
      $("div.tab-container").addClass("padding30");
    }
    const loadingContainer: HTMLElement = document
      .getElementsByClassName("loading")
      .item(0) as HTMLElement;
    loadingContainer.style.display = "block";
    const doc = new jsPDF("p", "mm");
    html2canvas(document.querySelector("#" + ele)).then(canvas => {
      // console.log(key, canvas.width, canvas.height);
      const pdf = new jsPDF("p", "pt", [canvas.width, canvas.height]);
      const imgData = canvas.toDataURL("image/jpeg", 1.0);
      const width = 210;
      const pageHeight = 300;
      const height = (canvas.height * width) / canvas.width;
      let heightLeft = height;
      let position = 0;
      doc.addImage(imgData, "PNG", 0, position, width, height);
      heightLeft -= pageHeight;
      while (heightLeft >= 0) {
        position = heightLeft - height;
        doc.addPage();
        doc.addImage(imgData, "PNG", 0, position, width, height);
        heightLeft -= pageHeight;
      }
      loadingContainer.style.display = "none";
      doc.save(name + ".pdf");
      // $('#' + ele).toggleClass('p45');
      $(".noprint").removeClass("hide");
      $("#disclaimer").toggleClass("hide");
      if (name === "report") {
        $("table.table").removeClass("table-padding");
        $("div.tab-container").removeClass("padding30");
      }
    });
  }

  getPrint(element) {
    console.log("print");
    // const printContent = document.getElementById(element).innerHTML;
    // const originalContents = document.body.innerHTML;
    // document.body.innerHTML = printContent;
    // window.print();
    // document.body.innerHTML = originalContents;

    const node = document.getElementById(element);
    // console.log(ele, node);
    domtoimage
      .toPng(node, { bgcolor: "#fff" })
      .then(function(dataUrl) {
        const img = new Image();
        img.src = dataUrl;
        const newImage = img.src;
        img.onload = function() {
          const pdfWidth = img.width;
          const pdfHeight = img.height;
          // FileSaver.saveAs(dataUrl, 'my-pdfimage.png'); // Save as Image
          let doc = new jsPDF();
          if (pdfWidth > pdfHeight) {
            console.log("landscape");
            doc = new jsPDF("l", "px", [pdfWidth, pdfHeight]);
          } else {
            console.log("portrait");
            doc = new jsPDF("p", "px", [pdfWidth, pdfHeight]);
          }
          const width = doc.internal.pageSize.getWidth();
          const height = doc.internal.pageSize.getHeight();
          doc.addPage();
          doc.addImage(newImage, "PNG", 0, 0, width, height);
          const filename = "report1" + ".pdf";
          doc.save(filename);
        };
      })
      .catch(function(error) {
        // Error Handling
        console.log("Error:", error);
      });
  }

  goToRoute(path, type) {
    type === 0
      ? this._route.navigate(["" + path + ""])
      : this._route.navigateByUrl("" + path + "");
  }

  CheckIfOnlyAlphabets(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } => {
      const regexp: RegExp = /^[A-z\s]+$/;
      const value = control.value;
      if (value === "") {
        return null;
      }
      return !regexp.test(value) ? { patternInvalid: regexp } : null;
    };
  }

  convertInvalidToValidDate(dateStr, notCheckValid = false): any {
    let date = new Date(dateStr);

    if (notCheckValid) {
      const [datePart, timePart] = dateStr.split("T");
      const [year, day, month] = datePart.split("-");
      const correctedDateStr = `${year}-${month}-${day}T${timePart}`;
      return correctedDateStr.split("T")[0];

    } else if (isNaN(date.getTime())) {
      //console.log("invalid date", dateStr);
      const [datePart, timePart] = dateStr.split("T");
      const [year, day, month] = datePart.split("-");
      const correctedDateStr = `${year}-${month}-${day}T${timePart}`;
      //date = new Date(correctedDateStr);
      return correctedDateStr.split("T")[0];
    }

    return dateStr.split("T")[0];
  }
}
